<script setup lang="ts">
import type { OrderCardDTO } from '@/api/orders'
import CareOrderSchedule from '@/views/care-order-schedule/CareOrderSchedule.vue'
import type { CareScheduleFocusPayload } from '@/views/care-order-schedule/types'

export type { CareScheduleFocusPayload }

const props = defineProps<{
  embedded?: boolean
  initialFocus?: CareScheduleFocusPayload | null
  externalRefreshNonce?: number
}>()

const emit = defineEmits<{
  close: [list?: OrderCardDTO[]]
  'orders-updated': [list: OrderCardDTO[]]
}>()
</script>

<template>
  <CareOrderSchedule
    :embedded="props.embedded"
    :initial-focus="props.initialFocus"
    :external-refresh-nonce="props.externalRefreshNonce"
    @close="(list?: OrderCardDTO[]) => emit('close', list)"
    @orders-updated="(list: OrderCardDTO[]) => emit('orders-updated', list)"
  />
</template>
